<script setup>
import { Head } from '@inertiajs/vue3';
import { onMounted, onRenderTriggered } from 'vue';
import AuthenticationCardLogo from '@/Components/AuthenticationCardLogo.vue';
import Footer from '@/Components/Footer.vue';

defineProps({
    policy: String,
});


onMounted(() => {
    window.scrollTo(0, 0);
    (function(d, s, id) {
        var js, tjs = d.getElementsByTagName(s)[0];
        // if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "https://app.termly.io/embed-policy.min.js";
        tjs.parentNode.insertBefore(js, tjs)})(document, "script", "termly-embed");
});

</script>

<template>
    <Head title="Disclaimer" />

    <div class="min-h-screen font-sans text-gray-900 antialiased relative py-8 bg-gray-100">
        <div class="flex flex-col items-center pt-6 sm:pt-0">
            <div>
                <AuthenticationCardLogo />
            </div>

            <div class="w-full sm:max-w-4xl mt-6 p-6 bg-white shadow-md overflow-hidden sm:rounded-lg prose">
                <div name="termly-embed" :data-id="policy"></div>
            </div>
        </div>
        <Footer />
    </div>

</template>
